import React from "react";

export default function SQL_Comments() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQL_Comments</h1>
      <p>This is the SQL_Comments component generated from the SQL JSON.</p>
    </div>
  );
}
